const cardItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20moody%20lighting%2C%20warm%20golden%20hour%20tones%2C%20movie%20poster%20aesthetic%2C%20deep%20shadows%2C%20elegant%20composition%2C%20no%20text%20or%20people&width=600&height=400&seq=card-movie-2026-01&orientation=landscape',
    title: '悬疑剧场：烧脑神作合集',
    desc: '精选10部高能反转悬疑片，每一部都让你猜不到结局，极速影视高清上线中。',
    tag: '悬疑',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20scene%20with%20soft%20warm%20lighting%2C%20cozy%20atmosphere%2C%20cinematic%20composition%2C%20golden%20and%20rose%20tones%2C%20elegant%20photography%20style%2C%20no%20text%20or%20people&width=600&height=400&seq=card-tv-2026-02&orientation=landscape',
    title: '甜宠剧场：高糖恋爱合集',
    desc: '最新都市甜宠剧一网打尽，治愈系恋爱故事让你甜到停不下来。',
    tag: '爱情',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20aesthetic%20with%20dynamic%20lighting%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20explosive%20atmosphere%2C%20dramatic%20composition%2C%20no%20text%20or%20people&width=600&height=400&seq=card-action-2026-03&orientation=landscape',
    title: '动作大片：肾上腺素飙升',
    desc: '好莱坞与国产动作巨制集结，震撼视效刺激体验，高清大屏观看更过瘾。',
    tag: '动作',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Stage%20performance%20with%20colorful%20warm%20lighting%2C%20entertainment%20show%20atmosphere%2C%20golden%20spotlights%2C%20elegant%20theater%20composition%2C%20vibrant%20yet%20sophisticated%2C%20no%20text%20or%20people&width=600&height=400&seq=card-variety-2026-04&orientation=landscape',
    title: '综艺大赏：笑点密集推荐',
    desc: '音乐竞演、户外真人秀、脱口秀，极速影视综艺频道周末必看清单。',
    tag: '综艺',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20scene%20with%20warm%20lighting%2C%20artistic%20composition%2C%20soft%20golden%20and%20crimson%20tones%2C%20dreamy%20atmosphere%2C%20elegant%20illustration%20style%2C%20no%20text%20or%20characters&width=600&height=400&seq=card-anime-2026-05&orientation=landscape',
    title: '动漫番剧：国漫日漫同步',
    desc: '热门连载番剧每日更新，从热血到治愈，极速影视动漫频道全收录。',
    tag: '动漫',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            精彩推荐
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            编辑精选影视专题，为你推荐最值得看的内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((card, i) => (
            <article
              key={i}
              className={`group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:-translate-y-1 transition-all ${
                i === 3 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-md whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}